import type { PageBannerCarouselItem } from 'LuxKit/Banners/types'
import { BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR, BANNER_BUTTON_TEXT_COLOR_VAR } from 'LuxKit/Banners/bannerButtonColorStyles'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { getImageUrl } from 'lib/image/imageUtils'
import type { LabV2HeaderBanner } from 'lib/labV2/headerBanners'
import { extractReactNodeText } from 'lib/string/extractReactNodeText'
import { rem } from 'polished'
import styled from 'styled-components'
import { renderHeaderBannerRichText } from './headerBannerRichText'
import { labV2HeaderBannerItem, type LabV2HeaderBannerCta } from './labV2HeaderBannerItem'

const HeaderBannerLeadingIcon = styled.img`
  height: ${rem(44)};
  width: auto;
  max-width: ${rem(132)};
  object-fit: contain;
  display: block;
`

function bannerActionButtonProps(cta: LabV2HeaderBannerCta) {
  return {
    kind: cta.style,
    size: 'small' as const,
    to: cta.path,
    children: cta.label,
  }
}

function bannerDescription(desktop: string, mobile?: string) {
  if (!mobile || mobile === desktop) {
    return <>{renderHeaderBannerRichText(desktop)}</>
  }

  return <>
    <CSSBreakpoint as="span" min="tablet">
      {renderHeaderBannerRichText(desktop)}
    </CSSBreakpoint>
    <CSSBreakpoint as="span" max="mobile">
      {renderHeaderBannerRichText(mobile)}
    </CSSBreakpoint>
  </>
}

function desktopAlignFor(description: string): 'start' | 'center' {
  return extractReactNodeText(renderHeaderBannerRichText(description)).length > 80 ? 'start' : 'center'
}

export function labV2HeaderBannerCarouselItem(
  banner: LabV2HeaderBanner,
  onDismiss?: () => void,
): PageBannerCarouselItem {
  const item = labV2HeaderBannerItem(banner)
  return {
    id: item.id,
    kind: item.kind,
    onDismiss,
    icon: item.iconImageId ? (
      <HeaderBannerLeadingIcon src={getImageUrl(item.iconImageId, { height: 88, quality: 'good' })} alt="" aria-hidden="true" />
    ) : undefined,
    children: bannerDescription(item.description.desktop, item.description.mobile),
    desktopAlign: item.description.mobile && item.description.mobile !== item.description.desktop
      ? desktopAlignFor(item.description.desktop)
      : undefined,
    actionButtonProps: item.cta ? bannerActionButtonProps(item.cta) : undefined,
    mobileActionButtonProps: item.mobileCta ? bannerActionButtonProps(item.mobileCta) : undefined,
    style: item.isCustomAppearance ? {
      background: item.backgroundCss,
      color: item.textColor,
      [BANNER_BUTTON_TEXT_COLOR_VAR]: item.textColor,
      [BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR]: item.ctaPrimaryTextColor,
    } : undefined,
  }
}
